// extracted by mini-css-extract-plugin
export var container = "_4r-0";
export var error = "_4r-9";
export var label = "_4r-5";
export var light = "_4r-6";
export var md = "_4r-3";
export var sm = "_4r-2";
export var thin = "_4r-8";
export var thinBold = "_4r-7";
export var vertical = "_4r-4";
export var xs = "_4r-1";